import { Badge } from "ui/components/badge";
import EmployeeSection from "@/modules/performance/components/section/employee";
import PerformanceStatusCell from "@/modules/performance/components/cells/status";
import React from "react";
import {
  fetchEmployeesSelfReview,
  fetchEmployeeById,
} from "@/modules/performance/team-performance/employee-reviews/api";
import { useFetch } from "@/hooks/useFetch";
import { useParams } from "react-router-dom";

const ReviewsOfSection = () => {
  const { quadId, employeeId } = useParams();
  const {
    data: employee,
    isLoading: isEmployeeLoading,
    isError: isEmployeeError,
  } = useFetch({
    queryKey: ["employee", employeeId],
    queryFn: () => fetchEmployeeById({ employeeId }),
  });

  const {
    data: selfReview,
    isLoading: isSelfLoading,
    isError: isSelfError,
  } = useFetch({
    queryKey: ["reviews-of", quadId, employeeId],
    queryFn: () => fetchEmployeesSelfReview({ quadId, employeeId }),
  });

  if (isEmployeeLoading || isSelfLoading) return <div>Loading...</div>;

  if (isEmployeeError || isSelfError)
    return <div>Error fetching employee or review</div>;

  return (
    <EmployeeSection
      title="Reviews Of"
      employee={employee}
      cardContent={
        <div className="flex items-center flex-col gap-.5">
          <span className="text-zinc-400 text-xs">Self Evaluation</span>
          <PerformanceStatusCell
            getValue={() => selfReview?.status || "pending"}
            className="text-xs gap-1"
          />
        </div>
      }
      href={selfReview?.id}
    />
  );
};

export default ReviewsOfSection;
